import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface ProgressIndicatorProps {
  currentStep: number;
  numSteps: number;
}

export const ProgressIndicator = ({
  currentStep,
  numSteps,
}: ProgressIndicatorProps) => {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View
      style={{
        height: 4,
        backgroundColor:
          theme.colors.progressIndicator.inactive.backgroundColor,
      }}
    >
      <View
        style={{
          backgroundColor:
            theme.colors.progressIndicator.active.backgroundColor,
          width: `${(currentStep / numSteps) * 100}%`,
          height: '100%',
        }}
      />
    </View>
  );
};

const stylesheet = createStyleSheet((theme) => ({}));
